import React from 'react';
import { useTranslation } from 'react-i18next';

import { MenuProvider } from '../../menuContext';
import AdministrationLayout from './Layout';
import { CollapsableUserContainer, CollapsableUserHeader } from './Users/CollapsableContentContainer';
import NoPaperPageContent from '../../components/Generic/NoPaperPageContent';
import { useUsersWithFilter } from '../../hooks';
import Loading from '../../components/Loading';
import { transformObjectId } from '../../services/apiPlatformTransformer';
import { Routes } from '../../routes';

const AdministrationUsers: React.FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'administration.users' });

  const [userList] = useUsersWithFilter();

  return (
    <>
      <MenuProvider>
        <AdministrationLayout>
          <NoPaperPageContent
            title={t('title')}
            noBackground={true}
            createButtonLink={{
              pathname: Routes.AdministrationUserCreate,
              state: true,
            }}
          >
            <br />
            {userList ? (
              <div>
                <CollapsableUserHeader />
                {userList.map(user => (
                  <CollapsableUserContainer key={transformObjectId(user)} user={user} />
                ))}
              </div>
            ) : (
              <Loading />
            )}
          </NoPaperPageContent>
        </AdministrationLayout>
      </MenuProvider>
    </>
  );
};

export default AdministrationUsers;
